import React from 'react';
import PropTypes from 'prop-types';

const CrumbName = ({name, ...rest}) => <span itemProp="name" {...rest}>{name}</span>;

CrumbName.propTypes = {
    name: PropTypes.string.isRequired
};

export default CrumbName;